import get from 'lodash/get';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { BaseMessage } from '../BaseMessage';
import { OAuthProviders } from 'common/utils/assets.utils';
import Description from './description';
import { sensorAuthorizationsByIdSelector } from 'state/selectors/sensors-authorizations';

const AutoDiscoveryMesage = ({
  title,
  extra_data = {},
  created_at,
  is_read = false,
  markAsRead,
  deleteMessage,
  dedup_key
}) => {
  const sensorAuthorizationsById = useSelector(
    sensorAuthorizationsByIdSelector
  );

  if (!extra_data.repos || !extra_data.sensor_authorization_id) {
    return null;
  }
  const repositories = extra_data.repos;

  const sensorName = get(
    sensorAuthorizationsById,
    `[${extra_data.sensor_authorization_id}].sensor_name`,
    ''
  );

  const logo = get(OAuthProviders, `[${sensorName.toLowerCase()}].logo`, null);

  return (
    <BaseMessage
      icon={logo}
      title={
        title ??
        `${repositories.length} New ${
          repositories.length === 1 ? 'repository' : 'repositories'
        } added!`
      }
      description={<Description repositories={repositories} />}
      date={moment(created_at)}
      isRead={is_read}
      markAsRead={markAsRead}
      deleteMessage={deleteMessage}
      id={dedup_key}
    />
  );
};

export default AutoDiscoveryMesage;
